import { Modifier } from '@popperjs/core';

export const createTooltipModifiers = (
    offset: [number, number],
): Partial<Modifier<any, any>>[] => [
    {
        name: 'flip',
        enabled: true,
        options: {
            fallbackPlacements: ['bottom', 'right', 'left'],
        },
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            boundary: 'viewport',
            padding: 16,
        },
    },
    {
        name: 'offset',
        options: {
            offset,
        },
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            boundary: 'viewport',
            padding: 16,
            altAxis: true,
        },
    },
    {
        name: 'arrow',
        enabled: true,
        options: {
            element: '[data-popper-arrow]',
            padding: 8,
        },
    },
    {
        name: 'arrowShadow',
        enabled: true,
        phase: 'main',
        fn: ({ state }) => {
            // This is all about adding the shadow underneath the arrow and the tooltip
            // Popper doesn't support this out of the box, so we need to add it manually
            const arrowElement = state.elements.arrow;
            const shadowElement = document.querySelector(
                '.tooltip-arrow-shadow',
            );

            if (arrowElement && shadowElement instanceof HTMLElement) {
                const { x, y } = state.modifiersData.arrow || {
                    x: 0,
                    y: 0,
                };
                shadowElement.style.position = 'absolute';
                shadowElement.style.left = `${x}px`;
                shadowElement.style.top = `${y}px`;
            }
        },
    },
];
